export const LANDING = '/'
export const SIGN_UP = '/signup'
export const SIGN_IN = '/signin'
export const HOME = '/home'
export const ACCOUNT = '/account'
export const DASHBOARD = '/dashboard'
export const ADMIN = '/admin'
export const PASSWORD_FORGET = '/pw-forget'